<ng-container *ngIf="viewType === resultViewTypes.FULL">
    <div class="view-type-full row">
        <div class="col-4 offset-4 d-flex flex-column align-items-center">
            <div class="text-center">{{'womac.results.score'|text}}</div>
            <div class="score m-3 text-center">{{statistics.score}}</div>
            <app-image class="image" [image]="scaleImage" [lazily]="false"></app-image>
            <div class="score m-4 text-center">{{scaleDescription}}</div>
            <div class="text-center">{{'womac.results.score.description'|text}}</div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="viewType === resultViewTypes.ROW">
    <div class="view-type-row d-flex flex-row">
        <app-protocol-summary-row-activity-info [activity]="activity" [activityAnalysis]="activityAnalysis" [displayConfig]="false"></app-protocol-summary-row-activity-info>
        <div class="flex-grow-1 row ">
            <div class="col-6 offset-3 d-flex flex-column align-items-center">
                <div class="text-center">{{'womac.results.score'|text}}</div>
                <div class="score m-3 text-center">{{statistics.score}}</div>
                <app-image class="image" [image]="scaleImage" [lazily]="false"></app-image>
                <div class="score m-3 text-center">{{scaleDescription}}</div>
            </div>
        </div>
    </div>
</ng-container>
